import { getEditor, isEnabled } from '../composables/editorsMap';
import { ListOrdered } from 'lucide-vue-next';
export const getOrderedListOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'ordered_list'),
    icon: ListOrdered,
    title: 'רשימת מספרים',
    action: () => editor?.chain().focus().toggleOrderedList().run(),
    isActive: () => editor?.isActive('orderedList'),
  };
};
